import { useTranslation } from 'react-i18next';
import { TextareaField, TextareaFieldProps } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const ReasonField = (props: Omit<TextareaFieldProps, 'name'>) => {
  const { t } = useTranslation();

  return (
    <TextareaField<InfluencerFormKeys>
      help={t('Tooltip.Default Selection Reason Help')}
      title={t('TextForm.Default Selection Reason')}
      placeholder={t<string>('TextForm.Contents Placeholder')}
      name={InfluencerSharedKeys.defaultEngagementSelectionReason}
      {...props}
    />
  );
};
